export default {
  // baseURL: '//duocodes.com/axcelerate2/',
  baseURL: '//healthcorp.com.au/axcelerate/',
  // baseURL: '//sg1.healthcorp.com.au/axcelerate/',
  // baseURL: 'http://localhost/axcelerate/',

  loginUrl: function() {
    return "https://stg.axcelerate.com/auth/user/login.cfm?return_to=";
  },

  checkCoupon: function() {
    return this.baseURL + 'coupon';
  },

  getCourses: function(orgID) {
    return this.baseURL + 'organisation/' + orgID;
  },

  createContact: function() {
    return this.baseURL + 'contact';
  },

  enrol: function() {
    return this.baseURL + 'enrol';
  },

  notify: function() {
    return this.baseURL + 'notify';
  },

  ewayURL: function() {
    return this.baseURL + 'ewayURL';
  },

  login: function() {
    return this.baseURL + 'login';
  },

  canRegister: function() {
    return this.baseURL + 'canRegister';
  },

  resetPassword: function() {
    return this.baseURL + 'resetPassword';
  },

  sendUsername: function() {
    return this.baseURL + 'sendUsername';
  },
}
